import { ethers as r } from "ethers";
import { StakingPoolsContractAbi as n } from "@deorderbook/contracts/abi";
import { HODLStakingPoolsAddress as e } from "@deorderbook/contracts";
import { signer as c, provider as i } from "./provider.mjs";
const s = () => new r.Contract(
  e,
  n
), p = (t = !1) => {
  const o = s();
  return t ? o.connect(c) : o.connect(i);
};
export {
  s as initHODLPoolContract,
  p as useHODLPoolContract
};
//# sourceMappingURL=hodlPoolContract.mjs.map
